import * as React from "react";
import type { SVGProps } from "react";
const SvgWifiIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="wifi_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M556.245 486.357a95.147 95.147 0 0 0-134.57 0l-1.878 1.92-178.773-178.773a32.597 32.597 0 0 0-46.08 0C54.827 449.621 61.739 683.691 210.347 832.341c148.65 148.651 382.72 155.563 522.837 15.446a32.597 32.597 0 0 0 0-46.123L554.368 622.805l1.877-1.877a95.147 95.147 0 0 0 0-134.57zM463.36 96.597a42.667 42.667 0 0 1 41.813-43.52 469.333 469.333 0 0 1 478.55 459.776 42.667 42.667 0 0 1-85.334 1.707 384 384 0 0 0-391.552-376.15 42.667 42.667 0 0 1-43.52-41.813zm4.267 212.95a42.667 42.667 0 0 1 41.813-43.52A256 256 0 0 1 770.475 516.82a42.667 42.667 0 1 1-85.334 1.707A170.667 170.667 0 0 0 511.104 351.36a42.667 42.667 0 0 1-43.52-41.813z"
    />
  </svg>
);
export default SvgWifiIcon;
